<template>
  <div class="cancro">
    <default-header />
    <v-main>
      <v-container fluid>
        <default-notice />
      </v-container>
    </v-main>
    <default-footer />
  </div>
</template>

<script>
export default {
  name: "cancro",
  components: {
    "default-header": () => import("../../home/components/header/index.vue"),
    "default-footer": () => import("../../home/components/footer/index.vue"),
    "default-notice": () => import("../components/notice/index.vue"),
  },
};
</script>
